import { completePlanning, deleteBulkPlanning } from "../tools/collectivePlanningService";

export function usePlanAction({ swalBox, t, errorBox, token }) {
  const deleteItem = async (item, onSuccess) => {
    const confirm = await swalBox(
      "warning",
      t("general.warningTitle"),
      "Planı silmek istediğinize emin misiniz ?",
      true,
      t("general.confirmText"),
      t("general.rejectText")
    );

    if (!confirm.isConfirmed) return;

    try {
      await deleteBulkPlanning(token,item);

      await swalBox(
        "success",
        t("general.successTitle"),
        "",
        false,
        t("general.OkayTitle")
      );

      if (onSuccess) onSuccess();
    } catch (err) {
      errorBox(err.response);
    }
  };

  const completePlan=async (item, onSuccess) => {
    const confirm =await swalBox(
        "warning",
        t("general.warningTitle"),
        "Sevkiyatı bitirmek istediğinize emin misiniz ?",
        true,
        t("general.confirmText"),
        t("general.rejectText")
      );
         
       if (!confirm.isConfirmed)return;
      
      try {
        await completePlanning(token,item);
  
        await swalBox(
          "success",
          t("general.successTitle"),
          "",
          false,
          t("general.OkayTitle")
        );
  
        if (onSuccess) onSuccess();
      } catch (err) {
        errorBox(err.response);
      }

  }

  return {
    deleteItem,
    completePlan
  };
}
